import dayjs from 'dayjs';
import { Job, OrderDetails } from '@ssar-app/domain';
import { Grid, GridItem } from '@chakra-ui/react';

export interface OrderDetailsSummaryProps {
  job?: Job;
  orderDetails?: OrderDetails;
}

export const OrderDetailsSummary = (props: OrderDetailsSummaryProps) => {
  return (
    <Grid templateColumns='repeat(6, 1fr)' gap={2}>
      {props.job && (
        <>
          <GridItem textAlign={'right'}>
            <strong>Program ID:</strong>
          </GridItem>
          <GridItem colSpan={5} marginLeft={1}>
            {props.job?.externalSystemRef || ''}
          </GridItem>
          <GridItem textAlign={'right'}>
            <strong>Project Number:</strong>
          </GridItem>
          <GridItem colSpan={5} marginLeft={1}>
            {props.job?.projectNumber || ''}
          </GridItem>
          <GridItem textAlign={'right'}>
            <strong>Message:</strong>
          </GridItem>
          <GridItem colSpan={5} marginLeft={1}>
            {props.job?.externalMessage || ''}
          </GridItem>
        </>
      )}
      <GridItem textAlign={'right'}>
        <strong>Project Name:</strong>
      </GridItem>
      <GridItem colSpan={5} marginLeft={1}>
        {props.orderDetails?.name || ''}
      </GridItem>
      {props.job && (
        <>
          <GridItem textAlign={'right'}>
            <strong>Submitted By:</strong>
          </GridItem>
          <GridItem colSpan={5} marginLeft={1}>
            {props.job?.userId || ''}
          </GridItem>
        </>
      )}
      <GridItem textAlign={'right'}>
        <strong>Client Contact:</strong>
      </GridItem>
      <GridItem colSpan={5} marginLeft={1}>
        {props.orderDetails?.contact?.name || ''}
      </GridItem>
      <GridItem textAlign={'right'}>
        <strong>Client Name:</strong>
      </GridItem>
      <GridItem colSpan={5} marginLeft={1}>
        {props.orderDetails?.contact?.clientName || ''}
      </GridItem>
      {props.job && (
        <>
          <GridItem textAlign={'right'}>
            <strong>Date Submitted:</strong>
          </GridItem>
          <GridItem colSpan={5} marginLeft={1}>
            {dayjs(props.job?.submittedDate).format(
              'YYYY-MMM-DD HH:mm:ss [GMT]ZZ',
            )}
          </GridItem>
        </>
      )}
    </Grid>
  );
};
